<template>
  <div>
    <BlocoFiltroPesquisa
      :nome-do-form="nomeDoForm"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <BuscarSelecionarProfissional
              @selecionadoProfissional="filtro.profissional_id = $event._id"
              @limparProfissional="filtro.profissional_id = null"
            />
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <CampoGenerico
              id="procedimento"
              :valor="filtro.procedimento"
              label="Procedimento"
              placeholder="ex: 19999999999"
              mascara="99999999999999999999"
              @atualizar="filtro.procedimento = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <CampoGenerico
              id="numero_guia"
              :valor="filtro.numero_guia"
              label="Número da Guia"
              placeholder="ex: 19999999999"
              mascara="99999999999999999999"
              @atualizar="filtro.numero_guia = $event"
            />
          </div>
        </div>
      </template>
      <template #toolbar>
        <Popover title="Enviar arquivo" placement="bottom">
          <button
            data-test-id="button-auto-1"
            type="button"
            class="btn"
            data-role="trigger"
          >
            <span class="fa fa-upload" /> Enviar arquivo
          </button>
          <template #popover>
            <div>
              <form @submit.prevent="enviar">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label for="arquivoPromed"> Selecione o arquivo </label>
                      <input
                        id="arquivoPromed"
                        data-test-id="input-arquivopromed"
                        type="file"
                        class="form-control"
                        accept=".xls,.xlsx"
                        @change="aoAlterarArquivo"
                      />
                      <span class="text-primary help-block">
                        O arquivo deve ser uma planilha no format do Excel (.xls
                        ou .xlsx) exatamente como foi enviado pela Promed.
                      </span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label for="refArquivoPromed"> Mês de referência </label>
                      <input
                        id="refArquivoPromed"
                        v-model="referencia"
                        v-mask="'99/9999'"
                        data-test-id="input-refarquivopromed"
                        type="text"
                        class="form-control"
                        placeholder="MM/AAAA"
                      />
                      <span class="text-primary help-block">
                        Informe o mês de referência do arquivo, formato:
                        "MM/AAAA".
                      </span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <p class="text-danger">{{ erroForm }}</p>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <button
                      data-test-id="button-auto-4"
                      class="btn btn-primary"
                      style="margin-top: 20px"
                      type="submit"
                      :disabled="erroForm || enviando"
                      >Enviar</button
                    >
                  </div>
                </div>
              </form>
            </div>
          </template>
        </Popover>
      </template>
    </BlocoFiltroPesquisa>
    <br />
    <div
      class="btn-group"
      role="group"
      style="display: flex; justify-content: center"
    >
      <button
        v-if="relatorios.length > maximoDePaginas"
        type="button"
        class="btn btn-primary"
        :disabled="paginaInicial <= 0"
        @click="paginaInicial--"
      >
        <span class="fa fa-chevron-left"></span>
      </button>
      <button
        v-for="(relatorioTitulo, index) in relatoriosTitulo"
        :key="index"
        type="button"
        class="btn btn-primary"
        :class="{ active: relatorioTitulo._id === relatorioAberto._id }"
        @click="abrirRelatorio(index)"
      >
        <p>
          <span v-if="relatorioTitulo.qtd_guias" style="font-weight: 600">
            {{
              `${formatarData(relatorioTitulo.data)} • ${
                relatorioTitulo.qtd_guias
              } guias`
            }}
          </span>
          <span v-else style="font-weight: 600">
            {{ formatarData(relatorioTitulo.data) }}
          </span>
        </p>
        <div>
          <div>▲ R$ {{ formatarDinheiro(relatorioTitulo.total_pago) }}</div>
          <div>▼ R$ {{ formatarDinheiro(relatorioTitulo.total_glosa) }}</div>
        </div>
      </button>
      <button
        v-if="relatorios.length > maximoDePaginas"
        type="button"
        class="btn btn-primary"
        :disabled="paginaInicial + maximoDePaginas >= relatorios.length"
        @click="paginaInicial++"
      >
        <span class="fa fa-chevron-right"></span>
      </button>
    </div>
    <br />
    <div v-if="relatorioAberto._id">
      <table class="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Data</th>
            <th>Descrição</th>
            <th>Guia</th>
            <th>Procedimento</th>
            <th>Total Pago</th>
            <th>Total Glosa</th>
            <th>Qtd. Guias</th>
          </tr>
        </thead>
        <tbody v-if="relatorioAberto.items && relatorioAberto.items.length">
          <tr v-for="(item, index) in relatorioAberto.items" :key="index">
            <td>{{ formatarData(item.data, 'DD/MM/YYYY') }}</td>
            <td>{{ item.descricao }}</td>
            <td>{{ item.numero_guia }}</td>
            <td>{{ item.procedimento }}</td>
            <td>R$ {{ formatarDinheiro(item.total_pago) }}</td>
            <td>R$ {{ formatarDinheiro(item.total_glosa) }}</td>
            <td>{{ item.qtd_guias }}</td>
          </tr>
        </tbody>
      </table>
      <div class="pull-right">
        <Pagination
          v-if="relatorioAbertoPaginador.total"
          v-model="relatorioAbertoPaginador.pagina"
          size="sm"
          boundary-links
          :total-page="Math.ceil(relatorioAbertoPaginador.total / 12)"
          @change="paginaAlteradaRelatorioAberto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BuscarSelecionarProfissional from '@/componentes/formulario/BuscarSelecionarProfissional'
import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import Popover from '@/componentes/ui/popover/Popover.vue'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import FaturamentoPromedServico from '@/servicos/FaturamentoPromedServico'
import * as formatadores from '@/utils/formatadores'

const faturamentoPromedServico = new FaturamentoPromedServico()

export default {
  directives: { mask: AwesomeMask },
  components: {
    BlocoFiltroPesquisa,
    BuscarSelecionarProfissional,
    CampoGenerico,
    Popover,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const servico = faturamentoPromedServico
    const nomeResultado = 'relatorios'
    const nomeDoForm = 'relatoriosPromedFiltro'
    const filtro = ref({
      nome_paciente: '',
      numero_guia: '',
      procedimento: '',
      profissional_id: '',
    })
    const maximoDePaginas = ref(4)
    const paginaInicial = ref(0)
    const relatorioAberto = ref({ _id: null, items: [] })
    const relatorioAbertoPaginador = ref({ pagina: 1, total: 0 })
    const enviando = ref(false)
    const referencia = ref('')
    const relatorio = ref(null)
    const relatorios = ref([])
    const pesquisa = usePesquisa({
      filtro,
      resultado: relatorios,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onPesquisar: async () => {
        relatorioAberto.value = { _id: null, items: [] }

        const { relatorios: listaRelatorios } =
          await faturamentoPromedServico.recuperarRelatorioFaturamentoPromed({
            params: filtro.value,
            id: '',
          })

        relatorios.value = listaRelatorios.sort(
          (r1, r2) => moment(r1.data) - moment(r2.data)
        )

        if (relatorios.value.length) {
          const relatorio = relatorios.value[0]
          relatorioAberto.value = { _id: relatorio._id }

          const response =
            await faturamentoPromedServico.recuperarRelatorioFaturamentoPromed({
              params: { ...filtro.value, skip: 0, limit: 12 },
              id: relatorio._id,
            })

          relatorioAbertoPaginador.value.total = response.count
          relatorioAberto.value.items = response.relatorio
        }
      },
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(60)
    return {
      servico,
      filtro,
      maximoDePaginas,
      paginaInicial,
      relatorioAberto,
      relatorioAbertoPaginador,
      enviando,
      referencia,
      relatorio,
      relatorios,
      ...pesquisa,
    }
  },

  computed: {
    relatoriosTitulo() {
      return this.relatorios.slice(
        this.paginaInicial,
        this.paginaInicial + this.maximoDePaginas
      )
    },
    erroForm() {
      if (!this.referencia || !this.relatorio)
        return `Informe os campos para enviar o arquivo`

      const dataSplit = this.referencia.split('/')
      const referenciaValida =
        dataSplit &&
        dataSplit.length &&
        dataSplit[0] <= 12 &&
        dataSplit[0] >= 1 &&
        dataSplit[1] >= 1999 &&
        dataSplit[1] <= 2999

      if (!referenciaValida) {
        return `Referência '${this.referencia}' inválida`
      }

      // verifica se o relatorio já foi enviado
      if (referenciaValida && this.relatorios.length) {
        const relatoriosExistentes = this.relatorios.map((r) => {
          const d = r.data.split('-')
          // devolve no formato MM/YYYY
          return `${d[1]}/${d[0]}`
        })

        if (relatoriosExistentes.includes(this.referencia)) {
          return `Já foi enviado um relatório para a referência ${this.referencia}`
        }
      }

      return null
    },
  },
  async mounted() {
    this.calcularMaximoDePaginas()
    window.addEventListener('resize', this.calcularMaximoDePaginas)
  },
  destroyed() {
    window.removeEventListener('resize', this.calcularMaximoDePaginas)
  },
  methods: {
    ...formatadores,
    aoAlterarArquivo(event) {
      this.relatorio = event.target.files[0]
    },
    async abrirRelatorio(index) {
      this.relatorioAberto = { _id: this.relatorios[index]._id }
      await this.pesquisarLinhasRelatorioAberto(0)
    },
    async pesquisarLinhasRelatorioAberto(skip) {
      const response =
        await faturamentoPromedServico.recuperarRelatorioFaturamentoPromed({
          params: { ...this.filtro, skip, limit: 12 },
          id: this.relatorioAberto._id,
        })
      this.relatorioAbertoPaginador.total = response.count
      this.$set(this.relatorioAberto, 'items', response.relatorio)
    },
    formatarData(data) {
      return moment.utc(data).format('MMM, YYYY')
    },
    calcularMaximoDePaginas() {
      const tamanhoDaTela = window.innerWidth
      if (tamanhoDaTela > 1536) this.maximoDePaginas = 7
      else if (tamanhoDaTela > 1280) this.maximoDePaginas = 5
      else if (tamanhoDaTela > 1024) this.maximoDePaginas = 4
      else if (tamanhoDaTela > 768) this.maximoDePaginas = 3
      else if (tamanhoDaTela > 640) this.maximoDePaginas = 2
      else this.maximoDePaginas = 1
    },
    async enviar() {
      this.enviando = true
      const dataSplit = this.referencia.split('/')
      if (this.erroForm) return
      const dataRelatorio = `01-${dataSplit[0]}-${dataSplit[1]}`
      const data = new FormData()
      data.append('relatorio', this.relatorio)
      data.append('data_relatorio', dataRelatorio)

      try {
        const response =
          await faturamentoPromedServico.enviarRelatorioFaturamentoPromed(data)
        this.$alert({ content: response.msg }).then(() => location.reload())
      } catch (err) {
        this.$alert(`Erro ao enviar o arquivo ${err}`)
      } finally {
        this.enviando = false
      }
    },
    paginaAlteradaRelatorioAberto(pagina) {
      this.relatorioAbertoPaginador.pagina = pagina
      this.pesquisarLinhasRelatorioAberto(12 * (pagina - 1))
    },
  },
}
</script>
